export default __webpack_public_path__ + "static/media/black-logo.c5834aca.png";